import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { ReactComponent as BaseVSign } from '../../assets/BookingBoard/confirmed-big.svg';
import { Tooltip } from '../Tooltip';
import useFormattingMap from '../../hooks/useFormattingMap';
import TimeAgoRenderer from './TimeAgoRenderer';

const VSign = styled(BaseVSign)`
  height: 20px;
  width: 20px;
`;

const Wrapper = styled.div`
  width: 100%;
  gap: 8px;
  display: flex;
  align-items: flex-end;
`;

const CheckedTimeAgoWithTime = ({ rowData, dataKey, className }) => {
  const { parsedLocalTime } = useFormattingMap();
  const value = get(rowData, dataKey);
  const date = parsedLocalTime(value);

  return value ? (
    <Tooltip body={date}>
      <Wrapper>
        <VSign className={className} />
        <TimeAgoRenderer rowData={rowData} dataKey={dataKey} disabledTooltip />
      </Wrapper>
    </Tooltip>
  ) : (
    <></>
  );
};

export default CheckedTimeAgoWithTime;
